<!-- <slideshow *ngIf="imageUrls && imageUrls.length" [imageUrls]="imageUrls"></slideshow> -->
<div class="modal fade show" id="m_modal_4" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" style="display: block; padding-left:
  0px;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{helpers.deriveNameFromS3Url(this.imageUrls[this.activeSlideIndex])}}</h5>
        <button type="button" class="close" data-dismiss="modal"
          aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body height-50">
        <h5 *ngIf="imageUrls && imageUrls.length && (docUploadedBy &&
          docUploadedBy.length)" style="color:#ef7e22 ;font-weight:bold">Photo
          Uploaded By : {{docUploadedBy}}</h5>
        <!-- <slideshow (onSwipeRight)="onPrevious()" (onSwipeLeft)="onNext()" (onSlideRight)="onNext()" (onSlideLeft)="onPrevious()" *ngIf="imageUrls && imageUrls.length" [imageUrls]="imageUrls"></slideshow> -->
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img class="d-block w-100" [src]="imageUrlsFirst" alt="First slide">
            </div>
            <ng-container *ngFor="let url of imageUrls">

            
            <div class="carousel-item">
              <img class="d-block w-100" [src]="url" alt="Second slide">
            </div>
          </ng-container>
            <!-- <div class="carousel-item">
              <img class="d-block w-100" src="..." alt="Third slide">
            </div> -->
          </div>
          <a (click)="onPrevious()" class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a  (click)="onNext()" class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Send message</button>
      </div> -->
    </div>
  </div>
</div>